import { c as _c } from "react/compiler-runtime";
import { CategoryID, MacroCategoryID } from '@sbt-web/network/types';
import { AutoContainer, type Props as AutoContainerProps } from './AutoContainer';
import { DefaultContainer, type Props as DefaultContainerProps } from './DefaultContainer';
import { RealEstateContainer } from './RealEstateContainer';
type Props = AutoContainerProps & DefaultContainerProps;
export const AdDetailContainer = props => {
  const $ = _c(6);
  const category = props.ad.category;
  if (category.id === CategoryID.Auto) {
    let t0;
    if ($[0] !== props) {
      t0 = <AutoContainer {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (category.parentId === MacroCategoryID.Immobili) {
    let t0;
    if ($[2] !== props) {
      t0 = <RealEstateContainer {...props} />;
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== props) {
    t0 = <DefaultContainer {...props} />;
    $[4] = props;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};